"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegisterDeviceTokenDtoPlatformEnum = void 0;
exports.instanceOfRegisterDeviceTokenDto = instanceOfRegisterDeviceTokenDto;
exports.RegisterDeviceTokenDtoFromJSON = RegisterDeviceTokenDtoFromJSON;
exports.RegisterDeviceTokenDtoFromJSONTyped = RegisterDeviceTokenDtoFromJSONTyped;
exports.RegisterDeviceTokenDtoToJSON = RegisterDeviceTokenDtoToJSON;
exports.RegisterDeviceTokenDtoToJSONTyped = RegisterDeviceTokenDtoToJSONTyped;
/**
 * @export
 */
exports.RegisterDeviceTokenDtoPlatformEnum = {
    Ios: 'ios',
    Android: 'android',
    Web: 'web'
};
/**
 * Check if a given object implements the RegisterDeviceTokenDto interface.
 */
function instanceOfRegisterDeviceTokenDto(value) {
    if (!('token' in value) || value['token'] === undefined)
        return false;
    if (!('platform' in value) || value['platform'] === undefined)
        return false;
    if (!('deviceFingerprint' in value) || value['deviceFingerprint'] === undefined)
        return false;
    if (!('timezoneId' in value) || value['timezoneId'] === undefined)
        return false;
    return true;
}
function RegisterDeviceTokenDtoFromJSON(json) {
    return RegisterDeviceTokenDtoFromJSONTyped(json, false);
}
function RegisterDeviceTokenDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'token': json['token'],
        'platform': json['platform'],
        'deviceFingerprint': json['deviceFingerprint'],
        'timezoneId': json['timezoneId'],
    };
}
function RegisterDeviceTokenDtoToJSON(json) {
    return RegisterDeviceTokenDtoToJSONTyped(json, false);
}
function RegisterDeviceTokenDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'token': value['token'],
        'platform': value['platform'],
        'deviceFingerprint': value['deviceFingerprint'],
        'timezoneId': value['timezoneId'],
    };
}
